/* unplugin-vue-components disabled */import script from "./SpecialTopics.vue?vue&type=script&lang=ts&setup=true"
export * from "./SpecialTopics.vue?vue&type=script&lang=ts&setup=true"

import "./SpecialTopics.vue?vue&type=style&index=0&id=7ea1a12c&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ea1a12c"]])

export default __exports__